import type { ComponentProps } from 'react';
import { FormattedDate, FormattedTime } from 'react-intl';

import { getGameDateFormat } from '#src/lib/gameDate.ts';

type TimeProps = Omit<ComponentProps<typeof FormattedTime>, 'value'>;

const DEFAULT_TIME_PROPS: TimeProps = {
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
};

export const GameDate = ({
  date,
  timeProps = DEFAULT_TIME_PROPS,
}: {
  date: Date;
  timeProps?: TimeProps;
}) => {
  const format = getGameDateFormat(date);

  if (format === 'time') {
    return <FormattedTime value={date} {...timeProps} />;
  }
  if (format === 'weekday') {
    return <FormattedDate value={date} weekday="short" />;
  }
  return <FormattedDate value={date} weekday="short" day="numeric" />;
};
